import React from "react";
import FeatureCard from "./FeatureCard";
import cardData from "./data";
import { Type, Anchor } from "discover.medical.react-component-library";
import { Link } from "react-router-dom";
import { useConfig } from "@eis-poc/lib-discover-medical-mfes";
import useCTA from "../../util/useCTA";
import { StyledDescriptionContent } from "./_.styled";

const FeatureCardContent = ({ contents }) => {
  const { hasCTA } = useCTA();

  const handleClick = (e, isGated) => {
    if (isGated) {
      hasCTA(e, "feature card content click");
    }
  };

  return (
    <>
      {contents?.map((content, index) => (
        <React.Fragment key={index}>
          {content.action?.type === "link" && (
            <Anchor
              fontWeight="bold"
              linkComponent={Link}
              to={content.action.route}
              onClick={(e) => handleClick(e, content.action.gated)}
              data-gated={content.action.gated ? "gated" : "open"}
            >
              {content.action.text}
            </Anchor>
          )}
          {content.description && (
            <>
              <Type element="p" fontSize="sm" marginBottom="sm">
                <StyledDescriptionContent
                  dangerouslySetInnerHTML={{ __html: content.description }}
                />
              </Type>
            </>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

const FeatureCards = ({
  data = cardData,
  defaultProductCode = "dmx",
  className,
}) => {
  const productCode =
    useConfig()?.productInfo?.productCode || defaultProductCode;
  return (
    <section className={className}>
      {data[productCode].map((card, index) => (
        <FeatureCard
          key={index}
          heading={card.heading}
          buttonText={card.action?.text}
          route={card.action?.route}
          landscapeSrc={card.imageSrc?.landscape}
          portraitSrc={card.imageSrc?.portrait}
          iconSrc={card.imageSrc?.icon}
          isGated={card.action?.gated}
        >
          <FeatureCardContent contents={card.contents} />
        </FeatureCard>
      ))}
    </section>
  );
};

export default FeatureCards;
